import { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { date } from "yup";


export const UserTargetAlert = (permissions: IPermissionProps) => {
    const [openAlertBox, setOpenAlertBox] = useState(false);
    const [runalert, setAlert] = useState(false);
    const [message, setMessage] = useState<string>("");  // ✅ use state for message
    const hasMounted = useRef(false);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const _roles: Array<number> = loginObj.roles.map(r => r.role_ID);

    useEffect(() => {
        if (!hasMounted.current) {
            hasMounted.current = true;
            return;
        }
    }, [runalert]);









    const loadSaleswiseMessage = async () => {
        const response = await Fetch("Dashboard/PoWiseTarget", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            const currentDate = new Date();
            let showECIMessage = 0;

            const day = currentDate.getDate();

            if (day >= 15 && day <= 25) {
                showECIMessage = 1;
            } else if (day > 25) {
                showECIMessage = 2;
            }
            if (data[0].totalreqToday < data[0].reqAverage) {
                setMessage("Team is receiving fewer requirements per PO compared to expectations. Please discuss with your client managers to improve inflow. A stronger requirement pipeline = higher chances of closures.");
                setAlert(true);
                setOpenAlertBox(true);
            } else if (data[0].totalservToday < data[0].servAverage) {
                setMessage("Service allocation per PO seems to be lagging. Please ensure better alignment between recruiters and the requirements shared.");
                setAlert(true);
                setOpenAlertBox(true);
            } else if (data[0].totalsubToday < data[0].subAverage) {
                setMessage("Submissions per PO are below benchmark. Kindly work with recruiters to increase resume quality and speed. More submissions = more chances for interviews");
                setAlert(true);
                setOpenAlertBox(true);
            } else if (data[0].totalecsToday < data[0].ecsAverage) {
                setMessage("Many submissions are not reaching end clients. Please filter resumes better before sending. Quality > Quantity");
                setAlert(true);
                setOpenAlertBox(true);
            } else if (data[0].totaleciToday < data[0].eciAverage && showECIMessage === 1) {
                setMessage("Interview rate per PO is dipping. Please review with recruiters why profiles aren’t being shortlisted.");
                setAlert(true);
                setOpenAlertBox(true);
            }
            else if (data[0].totaleciToday < data[0].eciAverage && showECIMessage === 2) {
                setMessage("Interview rate per PO is dipping. Please review with recruiters why profiles aren’t being shortlisted.");
                setAlert(true);
                setOpenAlertBox(true);
            }
            else if (data[0].totalsubToday < data[0].subPerECSAverage && (showECIMessage === 1 || showECIMessage == 2)) {
                setMessage("Submissions per ECS are below benchmark. Kindly work with recruiters to increase resume quality and speed.");
                setAlert(true);
                setOpenAlertBox(true);
            }
            else if (data[0].totalsubToday < data[0].subPerECIAverage && (showECIMessage === 1 || showECIMessage === 2)) {
                setMessage("Submissions per ECI are below benchmark. Kindly work with recruiters to increase resume quality and speed.");
                setAlert(true);
                setOpenAlertBox(true);
            }
        }
    };

    const loadRecruiterwiseMessage = async () => {
        const response = await Fetch("Dashboard/PoWiseTargetRecruiters", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            if (data[0].totalsubToday < data[0].subAverage) {
                setMessage("Submissions per PO are below benchmark. Kindly work with recruiters to increase resume quality and speed. More submissions = more chances for interviews");
                setAlert(true);
                setOpenAlertBox(true);
            } else if (data[0].totalecsToday < data[0].ecsAverage) {
                setMessage("Many submissions are not reaching end clients. Please filter resumes better before sending. Quality > Quantity");
                setAlert(true);
                setOpenAlertBox(true);
            } else if (data[0].TotaleciToday < data[0].eciAverage) {
                setMessage("Interview rate per PO is dipping. Please review with recruiters why profiles aren’t being shortlisted.");
                setAlert(true);
                setOpenAlertBox(true);
            }
            else if (data[0].totalsubToday < data[0].subPerECSAverage) {
                setMessage("Submissions per ECS are below benchmark. Kindly work with recruiters to increase resume quality and speed.");
                setAlert(true);
                setOpenAlertBox(true);
            }
            else if (data[0].totalsubToday < data[0].subPerECIAverage) {
                setMessage("Submissions per ECI are below benchmark. Kindly work with recruiters to increase resume quality and speed.");
                setAlert(true);
                setOpenAlertBox(true);
            }
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (_roles.includes(2)) {
                loadSaleswiseMessage();
            }
        }, 1000 * 60 * 120); // every 120 minutes
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (_roles.includes(3) || _roles.includes(21)) {
                loadRecruiterwiseMessage();
            }
        }, 1000 * 60 * 120); // every 60 minutessdd
        return () => clearInterval(interval);
    }, []);

    return (
        <Dialog
            visible={openAlertBox}
            style={{ width: "40vw", borderRadius: "1rem" }}
            header={
                <div className="flex items-center gap-2">
                    <span className="text-xl font-semibold text-gray-800">
                        Jobvritta Impression
                    </span>
                </div>
            }
            modal
            className="p-fluid rounded-2xl shadow-lg"
            onHide={() => setOpenAlertBox(false)}
        >
            <div className="flex flex-col items-center text-center gap-4 px-2 py-2">
                <p className="text-xl font-semibold text-gray-800 leading-relaxed">
                    {message}
                </p>
            </div>
        </Dialog>


    );
};
